import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GenericModalComponent } from "./generic-modal.component";
@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        GenericModalComponent
    ],
    exports: [
        GenericModalComponent
    ]
})
export class GenericModalModule { }
